import { useDispatch, useSelector } from 'react-redux';
import { useDigitalMarketingSlice } from '../slice';
import { selectDigitalMarketing } from '../slice/selectors';
import { useCallback } from 'react';

export const useAIGenerator = () => {
  const { actions } = useDigitalMarketingSlice();
  const dispatch = useDispatch();
  const {
    isGeneratingAIText,
    generatedTextData,
    errorGeneratingAIText,
    isGeneratingAIImage,
    generatedImageUrl,
    errorGeneratingAIImage,
    generatedImageTask,
    isEnhancingImage,
    errorEnhancingImage,
  } = useSelector(selectDigitalMarketing);

  const generateText = useCallback(
    (title: string, description: string) => {
      dispatch(actions.generateAITextStart({ title, description }));
    },
    [dispatch, actions]
  );

  const generateImage = useCallback(
    (title: string, description: string) => {
      dispatch(actions.generateAIImageStart({ title, description }));
    },
    [dispatch, actions]
  );

  const enhanceImage = useCallback(
    (user_image_url: string) => {
      dispatch(actions.enhanceImageStart({ user_image_url }));
    },
    [dispatch, actions]
  );

  return {
    generateText,
    generateImage,
    enhanceImage,
    isGeneratingAIText,
    generatedTextData,
    errorGeneratingAIText,
    isGeneratingAIImage,
    generatedImageUrl,
    errorGeneratingAIImage,
    generatedImageTask,
    isEnhancingImage,
    errorEnhancingImage,
  };
};
